import { Box, styled } from '@mui/material';
import React from 'react';

const StyledBox = styled(Box)({
  wordWrap: 'break-word',
  wordBreak: 'break-word',
  overflowWrap: 'break-word',
  whiteSpace: 'pre-wrap',
  maxWidth: '100%',
  overflow: 'hidden',
});

interface Props {
  text?: string | null;
  testId?: string;
}

export function MultilineText({ text, testId }: Props): React.JSX.Element {
  if (!text) {
    return <Box data-testid={testId} />;
  }

  const textToRender = text.trim();

  return (
    <StyledBox data-testid={testId}>
      {textToRender.split('\n').map((item, index) => {
        const itemKey = `text-line-${index}`;
        return <Box key={itemKey}>{item}</Box>;
      })}
    </StyledBox>
  );
}
